export default __webpack_public_path__ + "static/media/knife.26aedbe0.png";